/** 서버가 준 사유를 그대로 보여준다 — "메뉴판 사진이 아닌 것 같아요" 같은 판정은
 * 사용자가 다음에 뭘 해야 할지 아는 유일한 단서다.
 *
 * 문자열 detail 만 통과시킨다: pydantic 검증 실패는 detail 이 객체 배열이라
 * 그대로 그리면 사용자가 읽을 수 없는 내부 표현이 뜬다. 그런 경우는 fallback 이다.
 */
export function errorMessage(error: unknown, fallback: string): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  return typeof detail === "string" ? detail : fallback;
}
